module.exports = __webpack_public_path__ + "static/media/ce_mark.98fc3fde.png";